import Chat from "../components/writer/Chat";
import WriterDashboardLayout from "../components/WriterDashboardLayout";

function WriterChat(){
return(<WriterDashboardLayout>
    <Chat/>
</WriterDashboardLayout>)    
}
export default WriterChat